import _classCallCheck from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/work-station/training-cloud/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate, __metadata } from "tslib";
import { Component, Vue, Prop } from "vue-property-decorator";
import { I18nService } from "../i18n";

var DataCard = /*#__PURE__*/function (_Vue) {
  _inherits(DataCard, _Vue);

  var _super = _createSuper(DataCard);

  function DataCard() {
    var _this;

    _classCallCheck(this, DataCard);

    _this = _super.apply(this, arguments);
    _this.i18n = I18nService.getLang("front-courseMana");
    _this.i18nCommon = I18nService.getLang("commonField");
    _this.moreImg = require("../assets/more.png");
    _this.isActive = false;
    _this.isChangeMenu = false;
    _this.courseDataList = [];
    _this.indexList = [];
    _this.url = require("@/tc-front/src/assets/course/course-empty.png");
    _this.btnList = [{
      key: 1,
      uel: require("../assets/edit.png"),
      name: _this.i18nCommon.edit
    }, {
      key: 2,
      uel: require("../assets/release.png"),
      name: _this.i18nCommon.release
    }, {
      key: 3,
      uel: require("../assets/more.png"),
      name: _this.i18nCommon.more
    }];
    _this.moreList = [{
      id: 0,
      name: _this.i18n.stuMana
    }, {
      id: 1,
      name: _this.i18nCommon.copy
    }, {
      id: 2,
      name: _this.i18nCommon.delete
    }];
    _this.moreIndexList = [false, false, false];
    return _this;
  }

  _createClass(DataCard, [{
    key: "created",
    value: function created() {
      I18nService.event.$on(I18nService.I18nEventEnum.CLOCALE, this.changeLocale);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.getInitData();

      for (var i = 0; i < this.courseDataList.length; i++) {
        this.indexList.push(false);
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      I18nService.event.$off(I18nService.I18nEventEnum.CLOCALE, this.changeLocale);
    }
  }, {
    key: "changeLocale",
    value: function changeLocale() {
      this.i18n = I18nService.getLang("front-courseMana");
      this.i18nCommon = I18nService.getLang("commonField");
    }
  }, {
    key: "getInitData",
    value: function getInitData() {
      this.courseDataList = this.courseLsit;
    }
  }, {
    key: "mouseOverMore",
    value: function mouseOverMore(index) {
      this.moreImg = require("../assets/mores.png");
      this.isActive = true;
      this.indexList[index] = true;
    }
  }, {
    key: "mouseLeaveMore",
    value: function mouseLeaveMore(index) {
      this.moreImg = require("../assets/more.png");
      this.isActive = false;
      this.indexList[index] = false;
    }
  }, {
    key: "mouseOverMenu",
    value: function mouseOverMenu(index) {
      this.isChangeMenu = true;
      this.moreIndexList[index] = true;
    }
  }, {
    key: "mouseLeaveMenu",
    value: function mouseLeaveMenu(index) {
      this.isChangeMenu = false;
      this.moreIndexList[index] = false;
    }
  }, {
    key: "onGoPreview",
    value: function onGoPreview(i) {}
  }, {
    key: "onRelease",
    value: function onRelease(i) {}
  }, {
    key: "onEdit",
    value: function onEdit(i) {}
  }, {
    key: "onStudentManage",
    value: function onStudentManage() {}
  }, {
    key: "onDelete",
    value: function onDelete() {}
  }, {
    key: "onCopy",
    value: function onCopy() {}
  }]);

  return DataCard;
}(Vue);

__decorate([Prop(), __metadata("design:type", Array)], DataCard.prototype, "courseLsit", void 0);

DataCard = __decorate([Component({
  components: {}
})], DataCard);
export default DataCard;